var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ws-icon-title"},[(_vm.icon)?_c('i',{staticClass:"ws-icon-title__icon",class:_vm.icon}):_vm._e(),(_vm.image)?_c('img',{staticClass:"ws-icon-title__img",attrs:{"src":_vm.image}}):_vm._e(),_c('WsText001',{staticClass:"ml-8",attrs:{"h4":"","bold":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }